import useStorageClusterStore from '@/common/store/pinia/storageCluster';

const getClusterId = () => useStorageClusterStore().getClusterId();

export default getClusterId;
